{
  "id": "freyja",
  "pantheon": "norse",
  "name": {
    "pt-BR": "Freia",
    "en": "Freyja"
  },
  "icon": "gods/freyja",
  "portrait": "gods/freyja-portrait",
  "age": "classical",
  "freeUnitsOnAgeUp": {
    "valkyrie": 1
  },
  "unlocks": ["valkyrie", "disablot", "thundering-hooves", "sessrumnir"],
  "powers": ["forest-fire"],
  "meta": {
    "source": "Game files 19.17020 (techtree.xml)",
    "checkedAt": "2026-10-18",
    "confidence": "high",
    "note": "Odin, Thor. Focus: cavalry and heroes. Age tech ClassicalAgeFreyja."
  },
  "fieldMeta": {
    "freeUnitsOnAgeUp": {
      "source": "Game files 19.17020 (techtree.xml)",
      "checkedAt": "2026-10-18",
      "confidence": "high",
      "note": "ClassicalAgeFreyja: CreateUnit valkyrie quantity 1, generator AbstractTemple (spawns at a Temple)."
    }
  }
}
